import React from 'react';
import VotingTab from './AllianceManagement/VotingTab';
import './css/AllianceManagement.css';
import { PageShell, SectionCard } from '../components/ui';

const Voting = () => {
  return (
    <PageShell maxWidth="xl">
      <div className="alliance-management-page">
        <SectionCard className="am-tab-content" sx={{ p: { xs: 1.5, md: 2 } }}>
          <VotingTab />
        </SectionCard>
      </div>
    </PageShell>
  );
};

export default Voting;
